export default __webpack_public_path__ + "static/media/picture.cbcd0884.svg";